import { Haptics, ImpactStyle } from "@capacitor/haptics"
import { triggerHapticImpact } from "@/shared/lib/telegram"
import { detectPlatform } from "./detect"

export type HapticImpactStyle = "light" | "medium" | "heavy"

const capacitorStyle: Record<HapticImpactStyle, ImpactStyle> = {
	light: ImpactStyle.Light,
	medium: ImpactStyle.Medium,
	heavy: ImpactStyle.Heavy,
}

export function triggerImpact(style: HapticImpactStyle = "medium"): void {
	const platform = detectPlatform()

	if (platform === "android" || platform === "ios") {
		Haptics.impact({ style: capacitorStyle[style] }).catch(() => {})
		return
	}

	if (platform === "telegram") {
		triggerHapticImpact(style)
	}
}
